import { gql } from '@apollo/client';

export const GetMyFindQueryName = 'GetMyFind';

export const GET_MY_FIND_QUERY = gql`
  query ${GetMyFindQueryName}($findId: String!) {
    getMyFind(findId: $findId) {
      id
      name
      evId
      createdAt
      createdBy
      description
      updatedAt
      foundAt
      material
      era
      type
      note
      localization
      latitude
      longitude
      depth
      count
      situationType
      foundBy
      siteId
      groupIds
      amcrId
      amcrStatus
      amcrData(cacheOnly: false) {
        images
        files {
          id
          name
          sha512
          uploadedName
        }
      }
      shared
      tags
      visibility
      image
      images
    }
  }
`;
